
import React, { PureComponent } from 'react';
import MultiSelect from 'react-select';
import { PropTypes } from 'prop-types';

function onInputChange ( inputValue ) {

    if ( inputValue.indexOf( ',' ) !== -1 ) {

        const csvVals = Array.from( new Set( inputValue.split( ',' ).map( val => val.trim() ) ) );
        const selected = this.props.value === '' ? [] : this.props.value;

        csvVals.forEach( val => {

            this.props.options.forEach( opt => {

                if ( val !== '' && opt.value.toLowerCase() === val.toLowerCase() ) selected.push( opt );

            } );

        } );
        const selList = Array.from( new Set( selected ) );
        this.props.onChange( selList );

    }

}

class CSVMultiSelect extends PureComponent {

    render () {

        return (
            <div>
                <MultiSelect
                    value={this.props.value}
                    onChange={this.props.onChange}
                    onInputChange={onInputChange.bind( this )}
                    options={this.props.options}
                    isMulti={this.props.isMulti}
                    menuPlacement={this.props.menuPlacement}
                    maxMenuHeight={this.props.maxMenuHeight}
                />
            </div>
        );

    }

}
CSVMultiSelect.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.object.isRequired,
    isMulti: PropTypes.bool,
    menuPlacement: PropTypes.string,
    maxMenuHeight: PropTypes.number,
};
export default CSVMultiSelect;
